mutation($homeNumberId: ID!, $moodIds: [ID], $originalBody: String, $body: String!, $homeLanguageId: ID, $teamId: ID!, $tz: String, $messageFileId: ID) {
  messageCreate (homeNumberId: $homeNumberId, moodIds: $moodIds, originalBody: $originalBody, body: $body, homeLanguageId: $homeLanguageId, teamId: $teamId, messageFileId: $messageFileId) {
    id
    insertedAt(tz: $tz)
    direction
    canEdit
    involvesCurrentUser
    conversation {
      id
      homeNumber {
        id
        label
        formattedNumber
      }
      teacherPhoneNumber {
        id
        formattedNumber
        displayName
      }
    }
    bodies {
      id
      text
      isCanon
      homeLanguage {
        id
        name
        language
      }
    }
    messageFiles {
      id
      url
      height
      width
    }
    status
  }
}
